import React, { Component } from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid'

const FooterContainer = styled(Grid)`
  width:100vw;
  padding:40px 20%;
  box-sizing:border-box;
  background:#9fff9d;
  h3 {
    font-family: 'Averia Serif Libre', serif;
    font-size:200%;
    line-height:2.5;
  }
  p, a {
    line-height:2;
  }
  a {
    text-decoration:underline;
  }
`

const LogoArea = styled.div`
  display:flex;
  padding-top:15px;
`
const SecondaryLogoArea = styled.div`
  display:flex;
  border-top:1px solid rgba(0,0,0,0.5);
  border-bottom:1px solid rgba(0,0,0,0.5);
  padding:15px 0;
  margin-top:15px;
  img {
    display:flex;
  }
  p {
    font-size:12px;
    transform:translateY(-5px);
  }
`

class Footer extends Component {
  render() {
    return (
      <FooterContainer container spacing={3}>
        <Grid item xs={12} md={6}>
            <h3>
              Team
            </h3>
            <p>
              Carlo Ratti, <span className="affi">Director</span><br/>
              <a href="https://www.nadinagalle.com" target="_blank" rel="noopener noreferrer">Nadina Galle</a>, <span className="affi">Research Lead</span><br/>
              <a href="https://dylanhalpern.com" target="_blank" rel="noopener noreferrer">Dylan Halpern</a>, <span className="affi">Researcher + Visualization</span><br/>
              Sophie Nitoslawki, <span className="affi">Researcher</span><br/>
              Fábio Duarte, <span className="affi">Research Manager</span><br/>
              Francesco Pilla, <span className="affi">Research Advisor</span><br/>  
            </p>
            <h3 style={{lineHeight:1.25, marginTop:'40px'}}>
              Related Project
            </h3>
            <a href="http://senseable.mit.edu/treepedia" target="_blank" rel="noopener noreferrer">Treepedia</a>

          </Grid>

          <Grid item xs={12} md={6}>
            <h3 style={{lineHeight:1.25}}>
              Diversitree is a research project of:
            </h3>
            <LogoArea>
              <a href="http://senseable.mit.edu" target="_blank" rel="noopener noreferrer">
                <img src={`${process.env.PUBLIC_URL}/assets/mit_scl_logo_black.svg`} alt="MIT SCL Logo" style={{transform:'translateY(5px)', marginRight:"10px"}}/>
              </a>
              <a className="logo" href="https://www.ucd.ie/" target="_blank"  rel="noopener noreferrer">
                <img height="35" src={`${process.env.PUBLIC_URL}/assets/ucd.png`} alt="University College Dublin Logo" />
              </a>
            </LogoArea>
            <SecondaryLogoArea>
              <a className="logo" href="https://connectingnature.eu/" target="_blank"  rel="noopener noreferrer">
                <img height="100" src={`${process.env.PUBLIC_URL}/assets/connectingnature.png`} alt="Connecting Nature Logo" />
              </a>
              <p><br />
                  This research received partial funding from the Connecting Nature project (Grant Agreement No. 730222) under the European Community’s Framework Program Horizon 2020.
              </p>
            </SecondaryLogoArea>
            <p><br/><br/>
              For more information, please email <a href="mailto:senseable-contacts@mit.edu" target="_blank" rel="noopener noreferrer">senseable-contacts@mit.edu</a>
              <a href="https://accessibility.mit.edu/" target="_blank" rel="noopener noreferrer"><br/><br/>Accessibility</a>
            </p>

            
          </Grid>
      </FooterContainer>
    );
  }
}

export default Footer;